import { ISelectItem } from '@lla-platform/core/core-ui'

export enum OpportunityType {
  AirFilter = 'AirFilter',
  CabinFilter = 'CabinFilter',
  Wipers = 'Wipers',
  Rotate = 'Rotate',
  BalanceRotate = 'BalanceRotate',
  Alignment = 'Alignment',
  Bulb = 'Bulb',
  Fluids = 'Fluids'
}

export const OpportunityTypeToLabel: { [key: string]: string } = {
  AirFilter: 'Air Filter',
  CabinFilter: 'Cabin Filter',
  Wipers: 'Wipers',
  Rotate: 'Rotate',
  BalanceRotate: 'Balance',
  Alignment: 'Alignment',
  Bulb: 'Bulb',
  Fluids: 'Fluids'
}

// Mirror of OpportunityCodes (lla-api/Domain/Constants/OpportunityCodes.cs).
export const OPPORTUNITY_CODES: Record<OpportunityType, string> = {
  [OpportunityType.AirFilter]: 'UP-Air',
  [OpportunityType.CabinFilter]: 'UP-Cabin',
  [OpportunityType.Wipers]: 'UP-Wipers',
  [OpportunityType.Rotate]: 'UP-Rot',
  [OpportunityType.BalanceRotate]: 'UP-Bal',
  [OpportunityType.Alignment]: 'UP-Alig',
  [OpportunityType.Bulb]: 'UP-Bulb',
  [OpportunityType.Fluids]: 'UP-Fluids'
}

export const OpportunityTypeItems: ISelectItem[] = [
  {
    label: OpportunityTypeToLabel[OpportunityType.AirFilter],
    value: OpportunityType.AirFilter
  },
  {
    label: OpportunityTypeToLabel[OpportunityType.CabinFilter],
    value: OpportunityType.CabinFilter
  },
  {
    label: OpportunityTypeToLabel[OpportunityType.Wipers],
    value: OpportunityType.Wipers
  },
  {
    label: OpportunityTypeToLabel[OpportunityType.Rotate],
    value: OpportunityType.Rotate
  },
  {
    label: OpportunityTypeToLabel[OpportunityType.BalanceRotate],
    value: OpportunityType.BalanceRotate
  },
  {
    label: OpportunityTypeToLabel[OpportunityType.Alignment],
    value: OpportunityType.Alignment
  },
  {
    label: OpportunityTypeToLabel[OpportunityType.Bulb],
    value: OpportunityType.Bulb
  },
  {
    label: OpportunityTypeToLabel[OpportunityType.Fluids],
    value: OpportunityType.Fluids
  }
]
